import { initial } from 'lodash';
import { ARTIFACT_GROUP_ID, AS_ADMIN_NAMESPACE_NAME } from './lib/constants';
import { Elevations } from './lib/Elevations';
import { PagingMethods } from './lib/PagingMethods';
var constants = {
    ARTIFACT_GROUP_ID: ARTIFACT_GROUP_ID,
    AS_ADMIN_NAMESPACE_NAME: AS_ADMIN_NAMESPACE_NAME,
    DEFAULT_REQUEST_QUERY_OBJECT_PROPERTY_NAME: 'query',
    PagingMethods: PagingMethods,
    Elevations: Elevations,
};
var segmentCount = function (path) { return path.split('.').length; };
var parentPathOf = function (path) {
    return initial(path.split('.')).join('.');
};
var lastPathSegmentOf = function (path) {
    return path.split('.').pop();
};
export { constants, segmentCount, parentPathOf, lastPathSegmentOf };
//# sourceMappingURL=index.js.map